import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Navigate, Outlet, useLocation } from 'react-router-dom';

import { setAlert } from '../../actions/alert';

const getMembresiaMsg = (status) => {
    if(status === null || status === undefined){
        return 'No cuentas con una membresía activa. Adquiere una membresía para acceder a esta sección.';
    }
    if(status === 1){
        return 'Tu membresía se encuentra en periodo de gracia (venció pero aún no pasan 7 días). Renuévala para seguir accediendo.';
    }
    return 'Tu membresía ha vencido hace más de 7 días o fue cancelada. Adquiere una nueva para acceder.';
};

const RUTAS_SIN_MEMBRESIA = ['/dashboard', '/membresia', '/configuracion/perfil_personal', '/configuracion/metodo_pago'];

const PrivateRoute = ({ routePermission, children }) => {

    const location = useLocation();
    const dispatch = useDispatch();

    const { permisos } = useSelector(state => state.auth.usuario);
    const { membresia_actual } = useSelector(state => state.auth);

    const isAuthenticated = useAuth();
    const membresiaActiva = membresia_actual?.status === 0;
    const permitidaSinMembresia = RUTAS_SIN_MEMBRESIA.includes(location.pathname);

    let acceso_permiso = true;
    if(permisos && routePermission){
        acceso_permiso = ObjectByString(permisos, routePermission);
    }

    const bloqueadoPorMembresia = !!permisos && !!acceso_permiso && !membresiaActiva && !permitidaSinMembresia;

    useEffect(() => {
        if(bloqueadoPorMembresia){
            dispatch(setAlert(getMembresiaMsg(membresia_actual?.status), 'warning'));
        }
    }, [bloqueadoPorMembresia]);

    if(permisos){
        if(routePermission){
            acceso_permiso = ObjectByString(permisos, routePermission);

            if(!acceso_permiso){
                return <Navigate to='/login' replace />;
            }

            if(!membresiaActiva){
                if(permitidaSinMembresia){
                    return children ? children : <Outlet />;
                }
                return <Navigate to='/login' replace />;
            }

            return children ? children : <Outlet />;
        }else{
            if(!isAuthenticated){
                return <Navigate to='/login' replace />;
            }

            return children ? children : <Outlet />;
        }
    }else{
        if(!isAuthenticated){
            return <Navigate to='/login' replace />;
        }

        return children ? children : <Outlet />;
    }
}

const useAuth = () => {
    const token = localStorage.getItem('token');
    return !!token;
}

const ObjectByString = (o, s) => {
    s = s.replace(/\[(\w+)\]/g, '.$1');
    s = s.replace(/^\./, '');
    var a = s.split('.');
    for (var i = 0, n = a.length; i < n; ++i) {
        var k = a[i];
        if (k in o) {
            o = o[k];
        } else {
            return;
        }
    }
    return o;
}

export default PrivateRoute;
